import { render } from "./QC3.vue?vue&type=template&id=c15c79f4"
import script from "./QC3.vue?vue&type=script&lang=js"
export * from "./QC3.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/microgen/QC3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c15c79f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c15c79f4', __exports__)) {
    console.log('reload')
    api.reload('c15c79f4', __exports__)
  }
  
  module.hot.accept("./QC3.vue?vue&type=template&id=c15c79f4", () => {
    console.log('re-render')
    api.rerender('c15c79f4', render)
  })

}


export default __exports__